import script from "./CreateTask.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateTask.vue?vue&type=script&setup=true&lang=js"

import "./CreateTask.vue?vue&type=style&index=0&id=55b979ff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55b979ff"]])

export default __exports__